import { RouteConfig } from 'vue-router';
import * as handlers from '../handlers';

const routes: Array<RouteConfig> = [
  {
    path: '1',
    name: 'cmv-events',
    component: () => import('@/pages/quote/forms/commercialVehicles/pages/CommercialVehiclesEvents.vue'),
    meta: {
      back: handlers.dashboard
    }
  },
  {
    path: '2',
    name: 'cmv-client-events',
    component: () => import('@/pages/quote/forms/general/ClientEventsPage.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'cmv-events', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '3',
    name: 'cmv-vehicle-1-new',
    component: () => import('@/pages/quote/forms/commercialVehicles/pages/CommercialVehiclesAddVehicle1.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'cmv-driver-suspensions', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '3/:vehicleId',
    name: 'cmv-vehicle-1',
    component: () => import('@/pages/quote/forms/commercialVehicles/pages/CommercialVehiclesAddVehicle1.vue'),
    meta: {
      back: handlers.dashboard
    }
  },
  {
    path: '4',
    name: 'cmv-vehicle-2-new',
    component: () => import('@/pages/quote/forms/commercialVehicles/pages/CommercialVehiclesAddVehicle2.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'cmv-vehicle-1-new', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '4/:vehicleId',
    name: 'cmv-vehicle-2',
    component: () => import('@/pages/quote/forms/commercialVehicles/pages/CommercialVehiclesAddVehicle2.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'cmv-vehicle-1', params: { packageHash: this.$packageHash, vehicleId: this.$route.params.vehicleId } }).href
      }
    }
  },
];

export default routes;
